var _rect, _rect2, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllotedcarparking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white",
    stroke: "#4B5563"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4934 22.8398C26.4934 22.8398 25.5158 23.5902 25.7166 23.9081C25.9408 24.2629 26.6843 24.9604 27.052 24.9764C27.3467 24.9891 27.5616 24.4422 27.5616 24.4422",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69287 26.0452C9.69287 26.0452 10.93 26.3591 11.5379 25.7782C12.0148 25.3225 12.3635 24.1758 12.3635 24.1758",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.028 28.1807C11.028 28.1807 8.87224 27.8902 8.62444 26.8454C8.40916 25.9377 9.6927 24.7088 9.6927 24.7088C9.6927 24.7088 14.6679 21.6907 18.2387 20.9699C22.0228 20.2062 28.1202 20.9701 28.1201 21.237C28.1201 21.5039 27.2318 21.7434 27.0519 22.3053C26.7518 23.2423 28.1081 23.4983 28.3872 24.4418C28.6831 25.4419 28.6543 26.8455 28.3872 27.1124C28.1201 27.3793 26.7605 27.6467 26.7605 27.6467",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9661,
    cy: 27.9148,
    r: 1.73651,
    stroke: "black",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.1145,
    cy: 27.9148,
    r: 1.73651,
    stroke: "black",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3696 28.1816H21.4438",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2085 23.1068C14.2085 23.1068 14.5243 23.908 15.0341 23.908C15.5438 23.908 22.5119 23.6743 22.5119 23.6743M24.9155 22.0385L23.5801 23.6409L22.5119 23.6743M22.5119 23.6743V21.7715M19.5742 23.6409V21.7715",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.014 30.4365L28.2229 30.4364M32.5627 30.4364L31.6797 30.4365M31.6797 30.4365V26.0821M31.6797 30.4365L28.2229 30.4364M31.6797 11.2089L29.5525 9C29.5525 9 8.81167 9.00033 8.54581 9C8.27995 8.99967 7.92491 9.76567 8.014 10.3398C8.07926 10.7603 8.54581 11.2089 8.54581 11.2089H26.4576M31.6797 11.2089V17.3736M31.6797 11.2089H26.4576M31.6797 17.3736L26.4576 11.2089M31.6797 17.3736V26.0821M31.6797 26.0821L28.2229 30.4364",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllotedcarparking);
export default __webpack_public_path__ + "static/media/alloted car parking.1516cfbc6b7bba39e7c99337168a08fa.svg";
export { ForwardRef as ReactComponent };